import { defaultCategory, mediaPrefix } from 'src/env';

export const setUrlParam = (key: string, value: string) => {
  if ('URLSearchParams' in window) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    const newRelativePathQuery =
      window.location.pathname + '?' + searchParams.toString();
    window.history.pushState(null, '', newRelativePathQuery);
  }
};

export const getCategoryFromUrl = (url: string) => {
  let newUrl = url;
  if (newUrl.startsWith(mediaPrefix)) {
    newUrl = newUrl.substring(mediaPrefix.length);
  }
  if (newUrl.includes('/')) {
    newUrl = newUrl.split('/')[1];
  }
  return newUrl.replace(/\//g, '').split('?')[0] || defaultCategory;
};

export const getUrlWithTrailingSlash = (url) => {
  return url?.split(/[?#]/)[0];
};

export const getUrlWithoutQueryOrHash = (url) => {
  return url?.split(/[?#]/)[0].replace(/\/$/, '');
};

export const replaceHyphenWithUnderscore = (str) => {
  return str?.replace(/-/g, '_');
};

export const getPathLocale = (locale) => {
  return `/${locale}`;
};

export const getActualLocale = (locale) => {
  if (locale === 'pt-br') {
    return 'pt-pt';
  }

  return locale;
};

export const getActualUrl = (url: string) => {
  if (url.includes('/pt-br/')) {
    return url.replaceAll('/pt-br/', '/pt-pt/');
  }

  return url;
};

export const getSeoFormatUrl = (url: string) => {
  const [urlPath, urlQuery] = url.split('?');
  let formatUrl = urlPath;

  if (!/\/$/.test(formatUrl)) {
    formatUrl += '/';
  }
  if (urlQuery) {
    formatUrl += `?${urlQuery}`;
  }

  return formatUrl;
};

export const appendCurrentQueryParams = (destination = '', queryObject) => {
  const strArr = destination.split('?');
  let path = strArr[0];
  let queryParams = strArr[1] || '';

  delete queryObject?.topics;
  delete queryObject?.post;
  delete queryObject?.slug;

  for (const key in queryObject) {
    queryParams += `${key}=${queryObject[key]}&`;
  }

  if (queryParams.length === 0) {
    return path;
  }

  // replace last & if there is any
  return `${path}?${queryParams}`.replace(/&\s*$/, '');
};

export const jump2Hash = (hash) => {
  window.location.replace(hash);
};
